import React from 'react'

/**
 * Handle errors.
 *
 * Display single error message.
 *
 * @param {String} error
 */
export const handleErrors = error => renderError(error)
const renderError = error => <div key={error} className='text-danger text-center mt'>{error}</div>



// WEBPACK FOOTER //
// ./src/utils/form.js